import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AttributeTypeParams, AttributeTypes } from "@tSurya/Services/CartPlaceOrder/getAttributeService";
import { AttribureValueStateModel } from "@tSurya/Store/Data/AttributeValueState";
import { Draft } from "immer";

const initialState: AttribureValueStateModel = {
    isLoading: false,
    attributeValueResult: null,
};

const reducer = {
    "Data/AttributeValues/BeginLoadAttributeValues": (
        draft: Draft<AttribureValueStateModel>,
        action: { params: AttributeTypeParams },
    ) => {
        draft.isLoading = true;
    },
    "Data/AttributeValues/CompleteLoadAttributeValues": (
        draft: Draft<AttribureValueStateModel>,
        action: { result: AttributeTypes | null },
    ) => {
        draft.isLoading = false;
        draft.attributeValueResult = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
